import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { headerActions, referralActions, throwError, updateAppointment, bottomnavActions, customModalActions, getMlsInfo, saveOpportuntiyProperty } from 'actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { HEADER } from '_constants';
import _ from 'lodash';
import ContentLoader from 'components/common/loaders/ContentLoader';
import AddOpportunityNote from './AddOpportunityNote';
import AddOpportunityProperty from './AddOpportunityProperty';
import Panel from './panel';
import ContactNotes from './ContactNotes';
import { APPOINTMENT_STATUS, REFERRAL, USER_RATING, FLYER_TOAST_CONFIGURATION } from '../../../constants';
import { REASSIGNED_MESSAGE, DEVICE_TYPE } from '../../../constants/common.constants';
import { postHistoryEvent, updateOpportunity } from '../../../services';
import { isResponseSuccess } from 'helpers/utilities';
import { showServerResponse } from '../../../actions/modals.actions';
import AppStoreRating from '../../common/AppStoreRating';
import { toast } from 'react-toastify';
import FlyerToast from './FlyerToast';
import { markOpportunityDocumentRead } from '../../../actions';
import Opportunities from './Opportunities';

// TODO: Re-write HTML and css according to Selva's design - Remove all the inline styles from referral details.
const headerSettings =
{
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Referral',
  hasBackButton: true,
  hasNotificationIcon: true,
  showFooterWithBackButton: true
};

class ReferralDetails extends Component {
  static propTypes = {
    setHeader: PropTypes.func.isRequired,
    initReferral: PropTypes.func.isRequired,
    activeReferral: PropTypes.object,
    opportunities: PropTypes.array,
    activeAppointment: PropTypes.object,
    activeOpportunity: PropTypes.object,
    documents: PropTypes.array,
    match: PropTypes.object,
    history: PropTypes.object.isRequired,
    throwError: PropTypes.func.isRequired,
    userprofile: PropTypes.object,
    updateAppointment: PropTypes.func.isRequired,
    postHistory: PropTypes.func.isRequired,
    resetReferralDetail: PropTypes.func.isRequired,
    showServerResponse: PropTypes.func.isRequired,
    addContactNote: PropTypes.func.isRequired,
    updateCustomModal: PropTypes.func.isRequired,
    hideCustomModal: PropTypes.func.isRequired,
    changeActiveItem: PropTypes.func.isRequired,
    getMlsInfo: PropTypes.func.isRequired,
    saveOpportuntiyProperty: PropTypes.func.isRequired,
    setActiveOpportunity: PropTypes.func.isRequired,
    deviceType: PropTypes.number,
    savingProperty: PropTypes.bool.isRequired,
    additionalDocuments: PropTypes.array.isRequired,
    markOpportunityDocumentRead: PropTypes.func.isRequired
  }

  state = {
    referralContent: null,
    renderOpportunities: true,
    renderType: null,
    currentDetailCard: null,
    payloadObj: {},
    isOpenAddNote: false,
    note: '',
    isOpenAddProperty: false,
    opportunityPayload: {},
    propertyHeader: '',
    mlsId: '',
    mlsState: '',
    showUserRatingPopup: false,
    transform: null
  }

  _isMounted = false;

  updateReferralDetailCard = (card) => {
    this.setState({ currentDetailCard: card });
  }

  updateAppointmentStatus = async (eventStatusId, dispositionId, nextCard = null, successText, errorText) => {
    const statusResponse = await this.props.updateAppointment(this.props.activeAppointment, eventStatusId, dispositionId);
    if (isResponseSuccess(statusResponse)) {
      this.props.showServerResponse(statusResponse, successText, errorText, () => {
        this.updateReferralDetailCard(nextCard);
      });
    } else {
      this.updateReferralDetailCard(null);
      this.props.showServerResponse(false, null, REASSIGNED_MESSAGE, '/');
    }
  }

  gotoDetailCard = (cardname, message) => {
    this.updateReferralDetailCard(cardname);
    this.props.postHistory(this.props.activeReferral.contactKey, this.props.userprofile.memberKey, this.props.activeOpportunity.opportunityKey, message);
  }

  pullToRefreshHandler = () => {
    this.initilizeReferral();
  }

  showFlyerToast = (url, oppSource, documentMapping = {}) => {
    const isNotAndroid = this.props.deviceType !== DEVICE_TYPE.ANDROID;
    isNotAndroid && toast(<FlyerToast url={url} name={`You have a message from ${oppSource}`} onRead={(isRead = false) => {
      this.props.markOpportunityDocumentRead(documentMapping);
      isRead && this.showDocumentModal(url, oppSource);
    }} />, FLYER_TOAST_CONFIGURATION);
  }

  showDocumentModal = (url, oppSource) => {
    const name = ' ';
    const fileExtension = url.split('.').pop().toLowerCase();
    const mimeTypeMap = {
      'txt': 'text/plain',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'gif': 'image/gif',
      'png': 'image/png'
    };
    let mimeType = mimeTypeMap[fileExtension] || 'application/pdf';
    this.props.updateCustomModal(
      true,
      name,
      <div className={'flyer-modal'}>
        <object type={mimeType} data={url} width="100%" height="auto" scrolling="yes">
          <param name="view" value="fit" />
        </object>
      </div>,
      null,
      null,
      this.props.hideCustomModal,
      true,
      'xl',
      null,
      null,
      null,
      'flyer-modal-container'
    );
  }

  showReasonModal = (documentName, status, reason) => {
    const title = [documentName, status].filter(Boolean).join(' - ');
    this.props.updateCustomModal(
      true,
      title,
      <div className='document-reason-modal'>
        {reason}
      </div>,
      null,
      null,
      this.props.hideCustomModal,
      true
    );
  }

  initilizeReferral = async () => {
    try {
      this.props.setHeader(headerSettings);
      this.props.changeActiveItem('Referrals');
      const appointmentId = _.get(this.props, 'match.params.appointmentId', null);
      await this.props.initReferral(this.props.match.params.referralId, this.props.userprofile.memberKey, appointmentId);
      const { activeReferral, activeAppointment, activeOpportunity, opportunities, additionalDocuments } = this.props;
      const oppIds = opportunities.map(opp => opp.opportunityKey);
      const oppAddDocuments = additionalDocuments.filter(aDoc => oppIds.indexOf(aDoc.opportunityId) >= 0);
      const unreadDocuments = (oppAddDocuments || []).filter(oad => oad.isRead === false);
      const readDocuments = (oppAddDocuments || []).filter(oad => oad.isRead === true);
      const hasUnreadDoc = readDocuments.length === 0;
      if (!_.isEmpty(this.props.activeReferral)) {
        if (activeAppointment && activeAppointment.eventStatus && activeAppointment.eventStatus.id === APPOINTMENT_STATUS.TENTATIVE.id) {
          this.props.history.replace(`/leadacceptance/${activeReferral.contactKey}/opportunity/${activeOpportunity.opportunityKey}/appointment/${activeAppointment.id}/`);
          return;
        }
        if (_.isEmpty(activeAppointment) || _.isEmpty(activeOpportunity)) {
          throw Error(new Error('No Active Appointment/Opportunity'));
        }
        if (unreadDocuments && unreadDocuments.length > 0 && unreadDocuments[0] && hasUnreadDoc) {
          const firstUnreadDoc = unreadDocuments[0];
          const oppSource = _.get(activeReferral, 'leadSources[0].leadSource', '');
          this.showFlyerToast(firstUnreadDoc.documentURL,
            oppSource,
            firstUnreadDoc);
        }
      }
      const rating = _.get(this.props, 'match.params.showUserRatingPopup', '');
      if (rating === USER_RATING.SHOW_USER_RATING_POPUP) {
        this._isMounted && this.setState({ showUserRatingPopup: true });
      }
    } catch (err) {
      console.error(err);
      if (_.get(err, 'response.status', null) === 403) {
        this.props.throwError('goback', REASSIGNED_MESSAGE);
      } else {
        this.props.throwError('goback');
      }
    }
  }

  addPropertyClickHandler = (opportunity, title, mlsId = '', mlsState = '') => {
    this.setState({
      isOpenAddProperty: true,
      opportunityPayload: opportunity,
      propertyHeader: title,
      mlsId,
      mlsState
    });
  }

  cancelOpportunityProperty = () => {
    this.setState({ isOpenAddProperty: false });
  }

  getNoteValue = (value) => {
    this.setState({ note: value });
  }

  saveOpportunityNote = () => {
    const { note = '', payloadObj } = this.state;
    const data = {
      ...payloadObj
    };
    data.notes.unshift({ note });
    this.props.addContactNote(data);
    this.setState({ isOpenAddNote: false });
  }

  cancelOpportunityNote = () => {
    this.setState({ isOpenAddNote: false });
  }

  componentWillUnmount() {
    this.props.resetReferralDetail();
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    // Only initialize if memberKey is available, otherwise wait for componentDidUpdate
    if (this.props.userprofile?.memberKey) {
      this.initilizeReferral();
    }
  }

  componentDidUpdate(prevProps) {
    // Initialize when memberKey becomes available (after loadSession completes)
    if (!prevProps.userprofile?.memberKey && this.props.userprofile?.memberKey) {
      this.initilizeReferral();
    }
  }

  render() {
    const { activeReferral, hideCustomModal, deviceType } = this.props;
    let { notes = [] } = activeReferral;
    notes = notes.filter(note => note.type === REFERRAL.GENERAL);
    const { isOpenAddNote, isOpenAddProperty } = this.state;
    if (_.isEmpty(this.props.activeReferral)) {
      return <ContentLoader isLoading />;
    }

    return (
      <React.Fragment>
        <section className='page-content referrals-page'>
          <div className='page-content-body referrals-content-body'>
            <div className='referral-panel-container'>
              <Panel
                {...this.props}
                activeReferral={this.props.activeReferral}
                updateAppointmentStatus={this.updateAppointmentStatus}
                gotoDetailCard={this.gotoDetailCard}
                currentDetailCard={this.state.currentDetailCard}
                panelTransform={this.state.transform}
              />
            </div>
            <div className='referrals-container'>
              <div className='mb-4'>
                <ul className='opportunity-wrapper'>
                  {
                    this.props.opportunities.sort((a, b) => (new Date(b.timestampModified) - new Date(a.timestampModified))).map((data, index) => (
                      <li key={index}>
                        <Suspense fallback={<div>loading...</div>}>
                          <Opportunities
                            referral={this.props.activeReferral}
                            opportunity={data}
                            userprofile={this.props.userprofile}
                            documents={(this.props.documents || []).filter(d => d.opportunityId === data.opportunityKey)}
                            row={index}
                            key={index}
                            addPropertyClickHandler={this.addPropertyClickHandler}
                            showDocumentModal={this.showDocumentModal}
                            showReasonModal={this.showReasonModal}
                            showDocInModal={this.props.deviceType !== DEVICE_TYPE.ANDROID}
                            additionalDocuments={this.props.additionalDocuments}
                            markOpportunityDocumentRead={this.props.markOpportunityDocumentRead}
                            setActiveOpportunity={this.props.setActiveOpportunity}
                          />
                        </Suspense>
                      </li>
                    ))}

                </ul>
                <div className='accordian-wrapper'>
                  <div>
                    <div className='opportunity-col'>
                      <div className='tabs'>
                        <div className='tab'>
                          <input className='accordian-input' type='checkbox' id='chck2' />
                          <label className='tab-label primary-label additional-notes-section' htmlFor='chck2'>Additional Info</label>
                          <div className='tab-content' >
                            <ContactNotes notes={notes} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {
          isOpenAddNote && <AddOpportunityNote
            show={isOpenAddNote}
            hideModal={hideCustomModal}
            title={'Add Note'}
            getNoteValue={this.getNoteValue}
            saveStatus={this.saveOpportunityNote}
            cancelStatus={this.cancelOpportunityNote} />
        }
        {
          isOpenAddProperty &&
          <AddOpportunityProperty
            show={isOpenAddProperty}
            hideModal={this.cancelOpportunityProperty}
            title={this.state.propertyHeader}
            cancelAddProperty={this.cancelOpportunityProperty}
            searchProperty={this.props.getMlsInfo}
            opportunityPayload={this.state.opportunityPayload}
            saveProperty={this.props.saveOpportuntiyProperty}
            mlsId={this.state.mlsId}
            mlsState={this.state.mlsState}
            savingProperty={this.props.savingProperty}
          />
        }
        {
          this.state.showUserRatingPopup && deviceType && (deviceType === DEVICE_TYPE.IOS) &&
          <AppStoreRating referralId={this.props.match.params.referralId} deviceType={deviceType} />
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { referrals, userprofile, login } = state;
  return {
    activeReferral: referrals.activeReferral || {},
    opportunities: referrals.opportunities || [],
    appointments: referrals.appointments || [],
    activeAppointment: referrals.activeAppointment || {},
    activeOpportunity: referrals.activeOpportunity || {},
    documents: referrals.documents || [],
    properties: referrals.properties || [],
    buyOppStatusList: referrals.buyOppStatusList || [],
    sellOppStatusList: referrals.sellOppStatusList || [],
    userprofile: userprofile || {},
    deviceType: _.get(login, 'deviceType', null),
    savingProperty: _.get(referrals, 'savingProperty', false),
    additionalDocuments: _.get(referrals, 'additionalDocuments', [])
  };
};

const mapDispatchToProps = dispatch => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  initReferral: bindActionCreators(referralActions.initReferral, dispatch),
  throwError: bindActionCreators(throwError, dispatch),
  updateAppointment: bindActionCreators(updateAppointment, dispatch),
  resetReferralDetail: bindActionCreators(referralActions.resetReferralDetail, dispatch),
  postHistory: bindActionCreators(postHistoryEvent, dispatch),
  putOpportunity: bindActionCreators(updateOpportunity, dispatch),
  showServerResponse: bindActionCreators(showServerResponse, dispatch),
  addContactNote: bindActionCreators(referralActions.addContactNote, dispatch),
  updateCustomModal: bindActionCreators(customModalActions.updateCustomModal, dispatch),
  hideCustomModal: bindActionCreators(customModalActions.hideCustomModal, dispatch),
  changeActiveItem: bindActionCreators(bottomnavActions.changeActiveItem, dispatch),
  getMlsInfo: bindActionCreators(getMlsInfo, dispatch),
  saveOpportuntiyProperty: bindActionCreators(saveOpportuntiyProperty, dispatch),
  markOpportunityDocumentRead: bindActionCreators(markOpportunityDocumentRead, dispatch),
  setActiveOpportunity: bindActionCreators(referralActions.setActiveOpportunity, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReferralDetails));
